// const loadScript = require('load-script')
import load from './load'

const DEFAULT_SCRIPT = 'https://ask.qcloudimg.com/script/vendor/mathjax/MathJax.js';

const DEFAULT_OPTIONS = {
	jax: ['input/TeX', 'output/CommonHTML'],
	TeX: {
		extensions: ['autoload-all.js'],
	},
	messageStyles: 'none',
	showProcessingMessages: false,
	showMathMenu: false,
	showMathMenuMSIE: false,
	preview: 'none',
	delayStartupTypeset: true,
}

const loadMathJax = ({ macros: Macros, script, mathjaxConfig }) => {
	if (typeof window !== 'object') return;
	if (loadMathJax.called) {
		return;
	}
	loadMathJax.called = true;

	const config = {}
	config.script = script || DEFAULT_SCRIPT
	config.options = mathjaxConfig || DEFAULT_OPTIONS
	if (config.options.TeX === undefined) {
		config.options.TeX = {}
	}
	const TeX = Object.assign(config.options.TeX, { Macros })
	config.options = Object.assign(config.options, { TeX })

	if (window.MathJax) {
		window.MathJax.Hub.Config(config.options)
		window.MathJax.Hub.processSectionDelay = 0
		return
	}
	load(config.script, (err) => {
		if (!err) {
			window.MathJax.Hub.Config(config.options)
			// avoid flickering of the preview
			window.MathJax.Hub.processSectionDelay = 0
		}
	})
}

export default loadMathJax



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/formulaPlugin/mathjax/loadMathJax.js